import { ApiFormElementType } from "@/types/forms/form.types.ts";
import { ApiFieldTypes } from "@/types/custom-field.types.ts";

export interface ApiFormElementScaleSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;

  form_scale_id: number;
}

export interface ApiFormElementGoalsSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;
  is_single_rating: boolean;
  show_when_no_goals: boolean;

  form_scale_id: number;
  date_starts_at?: Date | null;
  date_ends_at?: Date | null;
}

export interface ApiFormElementWriteToFieldSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;

  target_type: ApiFormElementWriteToFieldTargetType;
  field_id?: number | null;
  field_type?: ApiFieldTypes | null;
  table_id?: number | null;
  table_mode?: ApiFormElementWriteToFieldTableMode | null;
  show_current_row: boolean;
  fill_in_all_columns: boolean | null;
  column_ids_to_fill: number[] | null;
}

export enum ApiFormElementWriteToFieldTargetType {
  field = "field",
  table = "table",
}

export enum ApiFormElementWriteToFieldTableMode {
  create_new = "create_new",
  create_multiple = "create_multiple",
  update_existing = "update_existing",
}

export interface ApiFormElementSelectOptionEdit {
  id?: number;
  title: string | null;
  description: string | null;
  emoji: string | null;
  value: number | null;
}

export interface ApiFormElementSelectSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;
  is_multiple: boolean;
  is_other: boolean;

  options: ApiFormElementSelectOptionEdit[];
}

export interface ApiFormElementOpenAnswerSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;
}

export interface ApiFormElementFileSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;
}

export interface ApiFormElementEmployeeNPSSettingsEdit {
  title: string | null;
  description: string | null;
  is_required: boolean;
  is_comment_enabled: boolean;
}

export interface ApiFormElementTextSettingsEdit {
  title: string | null;
  description: string | null;
  text: string | null;
}

export interface ApiFormElementEdit {
  id?: number;
  type: ApiFormElementType;
  reference_id?: number;

  scale_settings?: ApiFormElementScaleSettingsEdit;
  select_settings?: ApiFormElementSelectSettingsEdit;
  open_answer_settings?: ApiFormElementOpenAnswerSettingsEdit;
  file_settings?: ApiFormElementFileSettingsEdit;
  employee_nps_settings?: ApiFormElementEmployeeNPSSettingsEdit;
  goals_settings?: ApiFormElementGoalsSettingsEdit;
  write_to_field_settings?: ApiFormElementWriteToFieldSettingsEdit;

  text_settings?: ApiFormElementTextSettingsEdit;
}

export interface ApiFormSectionEdit {
  id?: number;
  title: string | null;
  description: string | null;
  elements: ApiFormElementEdit[];
}

export interface ApiFormPageEdit {
  id?: number;
  title: string | null;
  description: string | null;
  sections: ApiFormSectionEdit[];
}

export interface ApiFormEdit {
  pages: ApiFormPageEdit[];
}
